import { useRef, useEffect, type RefObject } from 'react'
import { select, type Selection } from 'd3'

export interface D3Dims {
  width: number
  height: number
}

export type D3Svg = Selection<SVGSVGElement, unknown, null, undefined>

export function useD3(
  renderFn: (svg: D3Svg, dims: D3Dims) => void,
  deps: unknown[]
): RefObject<SVGSVGElement | null> {
  const ref = useRef<SVGSVGElement | null>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const render = () => {
      const { width, height } = el.getBoundingClientRect()
      if (width <= 0 || height <= 0) return
      const svg = select(el)
      svg.selectAll('*').remove()
      renderFn(svg, { width, height })
    }

    const observer = new ResizeObserver(() => render())
    observer.observe(el)

    return () => observer.disconnect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return ref
}
